import React, { useEffect } from 'react'
import useFetchUserByToken from '../../hooks/useFetchUserByToken'
import { useLocation } from 'react-router-dom';

const Home = () => {

    const location = useLocation();

    const user = useFetchUserByToken()

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);

    return (
        <>
            <h3>Beranda</h3>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#" style={{
                        color: '#B5B5C3'
                    }}>Beranda</a></li>
                    <li class="breadcrumb-item active" aria- current="page" style={{
                        color: '#3F4254'
                    }}>Dashboard</li>
                </ol>
            </nav>
            <div className='row mt-3'>
                <h5>Halo, Selamat datang {user.user.firstName} {user.user.lastName}</h5>
            </div>
        </>
    )
}

export default Home
